import { Link } from "react-router-dom";
import "./getInTouch.scss"
import phone from "../../assets/images/phone.svg"
import email from "../../assets/images/email.svg"
import location from "../../assets/images/location.svg"
import facebook from "../../assets/images/facebook.svg"
import insta from "../../assets/images/insta.svg"
import LinkedIn from "../../assets/images/LinkedIn.svg"
import youtube from "../../assets/images/youtube.svg"
import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

export default function GetInTouch({openModal}) {
  
  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true
    });
  }, []);

  return (
    <>
      <div className="getin_wrapper" id="gallery">
        <div className="container">
          <div className="getin_content" data-aos-offset="500" data-aos-delay="100" data-aos="fade-left">
            <h2>Get In Touch</h2>
            <p>Contact us to customize your luxurious yachting experience or book your charter today.</p>
            <ul className="list-none contact_info">
              <li><span><img src={phone} alt="phone"/></span><Link to="tel:+1-876-431-0549">+1-876-431-0549</Link></li>
              <li><span><img src={email} alt="email"/></span><Link to="mailto:deuscharters@outlook.com">deuscharters@outlook.com</Link></li>
              <li><span><img src={location} alt="location"/></span><Link to="https://maps.app.goo.gl/A88E5jCiTpiGoYcy9" target="_blank">The monetgo bay yacht club, montego bay, st James parish, Jamaica</Link></li>
            </ul>
            <ul className="list-none social_info flex items-center">
              <li><Link to="https://www.instagram.com/deusyachting/" target="_blank"><img src={insta} alt="insta"/></Link></li>
            </ul>
            <button className="simple_btn" onClick={openModal}>Book Your Journey Now</button>
          </div>
        </div>
      </div>
    </>
  );
}
